
import { Options, Vue } from 'vue-class-component'
import CompletedMatchScore from '@/components/Frontend/CompletedMatch/index.vue'

@Options({
  components: {
    CompletedMatchScore
  }
})

export default class CompletedMatchScoreView extends Vue {}
